import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ShipmentState {
  loading: boolean;
  error: string | null;
  trackingId?: string;
  message?: string;
}

const initialState: ShipmentState = {
  loading: false,
  error: null,
};

const shipmentSlice = createSlice({
  name: "shipment",
  initialState,
  reducers: {
    fetchShipmentTrackingStart(
      state,
      action: PayloadAction<{ orderId: string }>
    ) {
      state.loading = true;
      state.error = null;
    },
    fetchShipmentTrackingSuccess(
      state,
      action: PayloadAction<{ trackingId: string }>
    ) {
      state.loading = false;
      state.trackingId = action.payload.trackingId;
    },
    fetchShipmentTrackingFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetTrackingState(state) {
      state.loading = false;
      state.error = null;
      state.trackingId = undefined;
      state.message = undefined;
    },
  },
});

// Actions
export const shipmentTrackingActions = {
  fetchTracking: createAction<{ orderId: string }>(
    `${shipmentSlice.name}/fetchTracking`
  ),

  fetchShipmentTrackingStart: shipmentSlice.actions.fetchShipmentTrackingStart,
  fetchShipmentTrackingSuccess:
    shipmentSlice.actions.fetchShipmentTrackingSuccess,
  fetchShipmentTrackingFailure:
    shipmentSlice.actions.fetchShipmentTrackingFailure,
  resetTrackingState: shipmentSlice.actions.resetTrackingState,
};

export const selectShipmentTracking = (state: any) => state.shipment;

export default shipmentSlice.reducer;
